import React, { memo } from 'react';
import { ActionBar, Button } from '@beef/ui-kit';
export var ModalActionBar = /*#__PURE__*/memo(function (_ref) {
  var onClick = _ref.onClick,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(ActionBar, {
    size: "m"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    variant: "main"
  }, text));
});